import HttpClient from "../HttpClient";

export class NotificationService {
  getNotifications(params: {
    limit: number;
    offset: number;
    userId?: number;
    userType?: string;
    referenceModelName?: string;
    referenceId?: number;
    channel?: string;
    sortField?: string;
    sortOrder?: "ASC" | "DESC";
  }) {
    const queryParams: any = {
      limit: params.limit,
      offset: params.offset,
      sort: JSON.stringify({ field: params.sortField || "createdAt", order: params.sortOrder || "DESC" }),
    };
    if (params.userId) queryParams.userId = params.userId;
    if (params.userType) queryParams.userType = params.userType;
    if (params.referenceModelName) queryParams.referenceModelName = params.referenceModelName;
    if (params.referenceId) queryParams.referenceId = params.referenceId;
    if (params.channel) queryParams.channel = params.channel;

    return HttpClient.get("/centaurus/notification/service", { params: queryParams });
  }
}
